export { PromotionTile } from "./PromotionTile";
